'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Divider } from '../Divider';
import { Typography } from '../Typography/Typography';
import { FooterContainer } from './FooterContainer';
import { styled } from '@mui/material/styles';
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const StyledType = styled(Typography)(({ theme }) => ({
    color: theme.tokens.FuelColorTextSecondary,
    textDecorationColor: theme.tokens.FuelColorTextSecondary,
    display: 'inline-block',
    width: '100%',
    textAlign: 'center'
}));
const StyledDivider = styled(Divider)(({ theme }) => ({
    backgroundColor: theme.tokens.FuelColorGray300,
    height: theme.spacing(0.5)
}));
export const FooterCopyright = React.forwardRef(({ text, year = currentYear, divider, sx, DividerProps, TypographyProps, ...props }, ref) => (_jsxs(_Fragment, { children: [divider && _jsx(StyledDivider, { ...DividerProps }), _jsx(FooterContainer, { ref: ref, sx: sx, ...props, children: _jsx(StyledType, { variant: 'caption', ...TypographyProps, children: text || `Copyright \u00A9 ${year} Deere & Company. All Rights Reserved.` }) })] })));
FooterCopyright.displayName = 'FooterCopyright';
